import BaseAPI from './base.api';

export default class NetworkHealthAPI extends BaseAPI {
  getAll = async (payload: { customerCode: string }) => {
    const response = await this.API.get('network-health', payload);
    return response.data;
  };
}
